import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { handleProjectTicket } from '../../api';
export default {
  name: 'ticketHandleDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      ticketHandleForm: {
        id: null,
        status: [],
        remark: ''
      },
      ticketHandleRules: {
        status: [{
          required: true,
          type: 'array',
          min: 1,
          message: '请选择工单状态',
          trigger: 'change'
        }]
      },
      ticketHandleLoading: false
    };
  },
  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  methods: {
    open: function open(id) {
      var _this = this;
      this.ticketHandleForm = {
        id: id,
        status: [],
        remark: ''
      };
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this.$refs.ticketHandleForm && _this.$refs.ticketHandleForm.clearValidate();
      });
    },
    submitTicketHandle: function submitTicketHandle() {
      var _this2 = this;
      this.$refs.ticketHandleForm.validate(function (valid) {
        if (!valid) return;
        _this2.submitFn();
      });
    },
    submitFn: function submitFn() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _this3.ticketHandleLoading = true;
              _context.p = 1;
              _context.n = 2;
              return handleProjectTicket({
                id: _this3.ticketHandleForm.id,
                remark: _this3.ticketHandleForm.remark
              });
            case 2:
              _this3.$message.success('处理成功');
              _this3.dialogVisible = false;
              _this3.$emit('success');
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
            case 4:
              _context.p = 4;
              _this3.ticketHandleLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }))();
    }
  }
};